/* tbh-sizes.js (2026-11-04, Sampath; item 12, option A of claude.ai/artifact/6eqYUQADiP8ZNrqmuGmAh6).
   "Size hint from past orders": on clothing, shoes, gloves and helmets a returning shopper sees the size
   they had before, as an orange ring on that size and one line under the sizes. NOTHING IS SELECTED for
   them, so a wrong guess cannot slip into an order.
   - Where a size comes from: a signed-in customer's own orders (snippets/tbh-shopper-data.liquid prints
     them on product and guide pages only), and sizes added to cart on this browser (recorded here after
     every /cart/add, read back from /cart.js; localStorage 'tbh-sizes', 30 newest, one per product).
   - Match: same brand and same kind of item first ("M in Monton"), then the same kind from any brand.
     Quiet when the size is not on this product or is sold out on it, and on bikes (no hint markup).
   - window.tbhSizeFor(vendor, type, sizes) is also used by the kit guides to pre-pick a size there.
   Each part is a no-op without its markup. */
(function () {
  'use strict';
  var KEY = 'tbh-sizes';
  var GROUPS = {
    tops: ['jersey', 'baselayer', 'jacket', 'vest & gilet', 'top wear', 't-shirt', 'casual t-shirt', 'tri top', 'skinsuit', 'trisuit'],
    bottoms: ['bibshorts', 'bibtights', 'shorts', 'tights', 'tri shorts', 'running short', 'jammer'],
    gloves: ['gloves'], shoes: ['cycling shoes'], helmets: ['helmet'], socks: ['socks'],
    warmers: ['arm warmers', 'leg warmers'], covers: ['shoe covers']
  };
  var WORD = { tops: 'jerseys and tops', bottoms: 'shorts and tights', gloves: 'gloves', shoes: 'shoes',
    helmets: 'helmets', socks: 'socks', warmers: 'warmers', covers: 'shoe covers' };
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  function groupOf(type) {
    var t = String(type || '').toLowerCase().trim();
    for (var g in GROUPS) if (GROUPS[g].indexOf(t) >= 0) return g;
    return null;
  }
  function norm(s) { return String(s || '').toLowerCase().replace(/^eu\s*/, '').replace(/\s+/g, ''); }
  function read() { try { var a = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; } }
  function write(a) { try { localStorage.setItem(KEY, JSON.stringify(a.slice(0, 30))); } catch (e) {} }

  /* Remember sizes after any add to cart, whoever made it (product form, quick add, guides, Saved). */
  function sizeOf(item) {
    var o = item.options_with_values || [];
    for (var i = 0; i < o.length; i++) if (/size/i.test(o[i].name)) return o[i].value;
    return null;
  }
  function remember() {
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      var list = read();
      (cart.items || []).forEach(function (it) {
        var s = sizeOf(it);
        if (!s || !groupOf(it.product_type)) return;
        list = list.filter(function (x) { return x.p !== it.product_id; });
        list.unshift({ p: it.product_id, v: it.vendor, t: it.product_type, s: s, n: it.product_title, at: Date.now(), src: 'cart' });
      });
      write(list);
    }).catch(function () {});
  }
  if (window.fetch && !window.fetch.tbhSizes) {
    var orig = window.fetch;
    var wrapped = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = orig.apply(this, arguments);
      if (/\/cart\/add(\.js)?(\?|$)/.test(url)) p.then(function (r) { if (r && r.ok) setTimeout(remember, 300); }).catch(function () {});
      return p;
    };
    wrapped.tbhSizes = true;
    window.fetch = wrapped;
  }

  /* Every size we know, newest first: this customer's orders, then this browser's adds. */
  function known() {
    var out = [];
    var el = document.getElementById('tbh-orders');
    if (el) { try { out = JSON.parse(el.textContent) || []; } catch (e) {} }
    out = out.map(function (x) { x.src = 'order'; return x; });
    return out.concat(read()).sort(function (a, b) { return (b.at || 0) - (a.at || 0); });
  }
  /* The best match for an item of this vendor and type, among `sizes` (values on offer). */
  window.tbhSizeFor = function (vendor, type, sizes) {
    var g = groupOf(type);
    if (!g) return null;
    var offer = {};
    (sizes || []).forEach(function (s) { offer[norm(s)] = s; });
    var all = known().filter(function (x) { return groupOf(x.t) === g && offer[norm(x.s)]; });
    var v = String(vendor || '').toLowerCase();
    var same = all.filter(function (x) { return String(x.v || '').toLowerCase() === v; });
    var hit = same[0] || all[0];
    if (!hit) return null;
    return { size: offer[norm(hit.s)], sameBrand: !!same[0], vendor: hit.v, title: hit.n, at: hit.at, src: hit.src, group: g };
  };

  /* The product page hint (snippets/tbh-size-hint.liquid). */
  function hint() {
    var box = document.querySelector('[data-tbh-sizehint]');
    if (!box) return;
    var data;
    try { data = JSON.parse(box.querySelector('script').textContent); } catch (e) { return; }
    var instock = data.sizes.filter(function (s) { return s.a; }).map(function (s) { return s.v; });
    var m = window.tbhSizeFor(data.vendor, data.type, instock);
    if (!m) return;
    var d = m.at ? new Date(m.at) : null;
    var when = d && !isNaN(d) ? MONTHS[d.getMonth()] + ' ' + d.getFullYear() : '';
    var where = m.sameBrand ? m.vendor : WORD[m.group];
    var verb = m.src === 'order' ? 'bought' : 'chose';
    var extra = [m.title, m.src === 'order' ? when : ''].filter(Boolean).join(', ');
    var line = box.querySelector('[data-tbh-sizehint-text]');
    line.textContent = '';
    line.appendChild(document.createTextNode('You ' + verb + ' '));
    var b = document.createElement('b'); b.textContent = m.size; line.appendChild(b);
    line.appendChild(document.createTextNode(' in ' + where + ' before' + (extra ? ' (' + extra + ').' : '.')));
    box.hidden = false;
    /* The ring: a rule keyed on the option input's own name and value, so it survives the theme
       re-drawing the picker on every variant change. */
    var inputs = document.querySelectorAll('variant-picker .js-option');
    var name = null;
    for (var i = 0; i < inputs.length; i++) {
      var fs = inputs[i].closest('[data-option]');
      if (fs && /size/i.test(fs.getAttribute('data-option')) && inputs[i].value === m.size) { name = inputs[i].name; break; }
    }
    if (!name) return;
    var st = document.createElement('style');
    var sel = '.opt-btn[name="' + name.replace(/"/g, '') + '"][value="' + m.size.replace(/"/g, '\\"') + '"] + .opt-label';
    st.textContent = sel + '{box-shadow:0 0 0 2px #fff,0 0 0 4px #f59523}';
    document.head.appendChild(st);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hint); else hint();
})();
